var React = require('react');

function LinkedIn (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"50","height":"50","transform":"translate(0.384766 0.727539)","fill":"white","fillOpacity":"0.01","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.3881 15.8691C14.5991 15.8691 16.3915 14.0466 16.3915 11.7983C16.3915 9.5501 14.5991 7.72754 12.3881 7.72754C10.1771 7.72754 8.38477 9.5501 8.38477 11.7983C8.38477 14.0466 10.1771 15.8691 12.3881 15.8691ZM15.8192 18.8296H8.9563V44.2721H15.8192V18.8296ZM36.4077 44.2721H43.2706V28.6596C43.2706 16.4935 30.4599 16.933 27.2572 22.9235V18.8296H20.3943V44.2721H27.2572V31.3195C27.2572 24.1263 36.4077 23.5249 36.4077 31.3195V44.2721Z","fill":"black","key":1})]);
}

LinkedIn.defaultProps = {"width":"51","height":"51","viewBox":"0 0 51 51","fill":"none"};

module.exports = LinkedIn;

LinkedIn.default = LinkedIn;
